import _ from 'lodash';
import React from 'react';
import { InvoiceStatusFilter } from '~/components';
import InvoiceSentFilter from '~/components/filters/InvoiceSentFilter';
import ReportPeriodFilter from './ReportPeriodFilter';
import InvoiceItemFilter from './InvoiceItemFilter';

export default function InvoiceFiltersBar({ filters, onChange }) {
  return (
    <>
      {(filters.invoiceServicesThroughPeriod?.start || filters.invoiceServicesThroughPeriod?.end) && (
        <ReportPeriodFilter
          value={filters.invoiceServicesThroughPeriod}
          placeholder="Services Through Date Range"
          onChange={({ target: { value } }) => onChange({ invoiceServicesThroughPeriod: value })}
        />
      )}

      {!_.isEmpty(filters.invoiceStatuses) && (
        <InvoiceStatusFilter
          value={filters.invoiceStatuses}
          onChange={({ target: { value } }) => onChange({ invoiceStatuses: value })}
        />
      )}

      {!_.isEmpty(filters.invoiceSent) && (
        <InvoiceSentFilter
          value={filters.invoiceSent}
          onChange={({ target: { value } }) => onChange({ invoiceSent: value })}
        />
      )}

      {!_.isEmpty(filters.invoiceItems) && (
        <InvoiceItemFilter
          value={filters.invoiceItems}
          onChange={({ target: { value } }) => onChange({ invoiceItems: value })}
        />
      )}
    </>
  );
}
